<template>
  <div>
    <v-layout>
      <v-flex xs6>
        <v-subheader class="title">過去訪問期間・回数</v-subheader>
      </v-flex>
      <v-flex>
        <v-layout>
          <v-subheader>過去訪問期間</v-subheader>
          <v-radio-group
            :disabled="disabled"
            v-model="minutesAgoIsLowerThanADay"
          >
            <v-layout>
              <v-flex xs6>
                <v-radio :value="false" label="日数で指定" />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  ref="minutesAgoAsDays"
                  v-model.number="minutesAgoAsDays"
                  @keydown.arrow-down.prevent
                  @keydown.arrow-up.prevent
                  @wheel.prevent
                  :disabled="disabled || minutesAgoIsLowerThanADay"
                  :class="{ disabled: minutesAgoIsLowerThanADay }"
                  :rules="[
                    rules.required,
                    rules.overZero,
                    rules.withinOneYear,
                    rules.integer,
                  ]"
                  type="number"
                  class="ma-0 pa-0 withoutSpinButton"
                >
                  <template v-slot:append-outer>
                    <span class="textAppended">日</span>
                  </template>
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-radio :value="true" label="時間で指定" />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  ref="minutesAgoAsHours"
                  v-if="minutesAgoIsLowerThanADay"
                  v-model.number="minutesAgoAsHours"
                  @keydown.arrow-down.prevent
                  @keydown.arrow-up.prevent
                  @wheel.prevent
                  :disabled="disabled"
                  :rules="[rules.required, rules.overZero, rules.integer]"
                  type="number"
                  class="ma-0 pa-0 withoutSpinButton"
                >
                  <template v-slot:append-outer>
                    <span class="text-no-wrap textAppended">時間</span>
                  </template>
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-radio-group>
        </v-layout>
      </v-flex>
    </v-layout>
    <div>
      <PeriodSlider
        v-model="orderDescription.minutesAgo"
        :disabled="disabled"
      />
    </div>
    <v-layout>
      <v-flex xs4>
        <v-layout>
          <v-subheader class="pt-2">過去訪問回数</v-subheader>
          <v-text-field
            v-model.number="orderDescription.visitCount"
            @keydown.arrow-down.prevent
            @keydown.arrow-up.prevent
            @wheel.prevent
            :rules="[rules.required, rules.overOne, rules.integer]"
            :disabled="disabled"
            type="number"
            class="withoutSpinButton"
          >
            <template v-slot:append-outer>
              <span class="text-no-wrap">回以上</span>
            </template>
          </v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import PeriodSlider from '@/components/App/AppDeliveryTargetAdvancedSettingPeriodSlider'

/**
 * キャンペーンで設定できる項目をコピーしてシミュレーションでも使う
 * という関係性からキャンペーンからのimportを許容する
 */
import { TargetVisitorConsts } from '@/models/CampaignOperation'
import { getMenuSetting } from '@/components/Advertiser/Operation/IO/Service/getMenuSettingService'
import { getOrderDescription } from '@/components/Advertiser/Operation/IO/Service/getOrderDescriptionService'

const ONE_DAY = 60 * 24

export default {
  name: 'AppDeliveryTargetAdvancedSetting',
  components: { PeriodSlider },
  props: {
    campaign: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    orderDescription() {
      return getOrderDescription(this.campaign)
    },
    visitCount: {
      get() {
        return this.orderDescription.visitCount
      },
      set(value) {
        this.orderDescription.visitCount = value === '' ? undefined : value
      },
    },
    minutesAgo() {
      return this.orderDescription.minutesAgo
    },
    minutesAgoIsLowerThanADay: {
      get() {
        return this.minutesAgo < ONE_DAY
      },
      set(value) {
        if (value) {
          this.orderDescription.minutesAgo = TargetVisitorConsts.MAX_HOURS * 60
        } else {
          this.orderDescription.minutesAgo = ONE_DAY
        }
      },
    },
    minutesAgoAsDays: {
      get() {
        return Math.floor(this.minutesAgo / 60 / 24)
      },
      set(newDays) {
        if (newDays === 0) {
          this.orderDescription.minutesAgo = 0
        } else {
          const days = Math.min(
            Number(newDays) || 1,
            TargetVisitorConsts.MAX_DAYS,
          )
          this.orderDescription.minutesAgo = days * 60 * 24
        }
      },
    },
    minutesAgoAsHours: {
      get() {
        return Math.floor(this.minutesAgo / 60)
      },
      set(newHours) {
        if (newHours < 1) {
          this.orderDescription.minutesAgo = newHours * 60
          return
        }
        const hours = Math.min(
          Number(newHours) || 1,
          TargetVisitorConsts.MAX_HOURS,
        )
        this.orderDescription.minutesAgo = hours * 60
      },
    },
    rules() {
      return getMenuSetting(this.campaign).validations.advanced
    },
  },
}
</script>

<style scoped></style>
